<template>
  <div
    class="component images"
    :data-count="data.content.length"
    @click="$store.commit('SET_CONTACT', true)"
    @mouseenter="$store.commit('SET_POINTER', 'pointer')"
    @mouseleave="$store.commit('SET_POINTER', 'default')"
  >
    <ImageBlock
      v-for="(image, key) in data.content"
      :key="key"
      :data-type="'multiple'"
      :data="image"
      :hasScale="false"
    />
  </div>
</template>

<script>
import ImageBlock from '@/components/ImageBlock.vue';

export default {
  name: 'ImagesBlock',

  components: {
    ImageBlock,
  },

  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.images {
  width: 100%;
  padding: $vertical-padding $extra-horizontal-padding;

  @include mq($until: ipadL) {
    padding: $mobile-vertical-padding $extra-mobile-horizontal-padding;
  }

  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @include mq($until: ipadL) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &[data-count="2"] {
    .image {
      width: calc(660px * var(--rw));

      @include mq($until: ds) {
        width: calc((540px) * var(--rw));
      }

      @include mq($until: ipadL) {
        width: 100%;
      }
    }

    & ::v-deep .image__picture {
      height: calc(840px * var(--rw));
    }
  }

  &[data-count="3"] {
    .image {
      width: calc(450px * var(--rw));

      @include mq($until: ipadL) {
        width: 100%;
      }
    }

    & ::v-deep .image__picture {
      height: calc(600px * var(--rw));
    }
  }
}
</style>
